import { Row } from 'antd';
import styled from 'styled-components';

export const ActionBar = styled(Row)`
  justify-content: 'end';
  margin-bottom: 18px;
`;

export const StyledContainer = styled.div`
  white-space: pre-wrap;

  .draft > td:not(.actions) {
    background-color: ${({ theme }) => theme.color.sunset_orange_2};
    border-bottom-color: ${({ theme }) => theme.color.conditional_divider};
    opacity: 0.5;
    transition: 0.3s;
  }

  .ant-table-wrapper .ant-table-tbody > .draft.ant-table-row:hover > td:not(.actions) {
    background-color: ${({ theme }) => theme.color.sunset_orange_2};
    opacity: 1;
  }

  .channel,
  .tactic,
  .monthly-spent,
  .buying-metric,
  .buy-rate,
  .sell-rate,
  .measure,
  .benchmark,
  .formats,
  .cost,
  .costs-fee,
  .notes,
  .benchmark {
    white-space: pre-wrap;
  }

  .benchmark {
    min-width: 120px;
  }

  .product {
    min-width: 220px;
  }

  .tactic {
    min-width: 230px;
  }

  .monthly-spent,
  .channel {
    min-width: 150px;
  }

  .buying-metric,
  .currency,
  .cost,
  .costs-fee {
    min-width: 170px;
  }

  .currency {
    min-width: 120px;
  }

  .buy-rate,
  .sell-rate {
    min-width: 106px;
  }

  .measure,
  .formats,
  .notes {
    min-width: 250px;
  }

  .actions {
    min-width: 150px !important;
    width: 150px !important;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th.actions {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
